import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { zodResolver } from '@hookform/resolvers/zod';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { z } from 'zod';
import { AuthLayout } from '@/components/AuthLayout';
import { api } from '@/lib/api';
const schema = z.object({ new_password: z.string().min(12) });
export function ResetPasswordPage() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const token = params.get('token') ?? '';
    const [serverError, setServerError] = useState(null);
    const form = useForm({
        resolver: zodResolver(schema),
        defaultValues: { new_password: '' },
    });
    const mutation = useMutation({
        mutationFn: async (values) => {
            await api.post('/auth/reset-password/', { token, ...values });
        },
        onSuccess: () => navigate('/login', { replace: true }),
        onError: (err) => {
            setServerError(err.response?.data?.error?.message ?? 'Reset failed.');
        },
    });
    if (!token) {
        return (_jsx(AuthLayout, { title: "Reset link missing", subtitle: "Open the link from your email again.", children: _jsx(Link, { to: "/login", className: "block text-sm font-medium text-foreground hover:underline", children: "Back to sign in" }) }));
    }
    return (_jsx(AuthLayout, { title: "Set a new password", subtitle: "Choose a strong password you don't reuse elsewhere.", children: _jsxs("form", { className: "space-y-4", onSubmit: form.handleSubmit((v) => mutation.mutate(v)), children: [_jsxs("div", { className: "space-y-1", children: [_jsx("label", { htmlFor: "new_password", className: "text-sm font-medium", children: "New password" }), _jsx("input", { id: "new_password", type: "password", autoComplete: "new-password", className: "block w-full rounded-md border border-input bg-background px-3 py-2 text-sm", ...form.register('new_password') }), form.formState.errors.new_password && (_jsx("p", { className: "text-xs text-destructive", children: form.formState.errors.new_password.message }))] }), serverError && _jsx("p", { className: "text-xs text-destructive", children: serverError }), _jsx("button", { type: "submit", className: "w-full rounded-md bg-primary px-3 py-2 text-sm font-medium text-primary-foreground disabled:opacity-50", disabled: mutation.isPending, children: mutation.isPending ? 'Updating…' : 'Update password' })] }) }));
}
